var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8674",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8674",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEEElEQVR4nO3dz4vcZADG8e+79IfSolU8iLYiIhXRHkRBFEHatUKhrqAe/AOkHkVEUKhYqu2loPUm4qGIvYqgsJfSigVXqOhBPVgVhF3rwYOwWJW17uMh2TKbzezsJJnJO2+ez2U7mUzy8D5NZrKTZMHMzMzMzMzMzMzMzCxtYaMzStoDPAdMA7cD20YVKhGXgV+AM8D7IYTvNvKigYVI2gq8DTwPTNVJ2GHLwLvAiyGEpfVmXLeQvIxZYG9z2TrtLHBgvVIG/Y8/icto0j7grUqvlLRH0n9a7QtJ05L8/jGApG2SHpM0VxjDK5LuqbLAkyVlbBlB9qRJ2lJSyvBbiaTvCwuZHkHeTpC0vzCW31ZZyGJhId5NVSRpe2EsF/vN2/dTliStmjGEUHj+aeA94Ma6gROzABwKIcz2Thw0nlen91vqBgr5Dbh52LQdMR9CuK13wjgKEdbXoPHqV4iPvCOzqakF9Wu8K5raY3gLiYwLiYwLiYwLiYwLiYwLiYwLiYwLiYwLiYwLicxEFiLpDUnXtJ1jFCayEOAg8JGka9sO0rRJLQTgADAraXvbQZo0yYUAPEpWynVtB2nKpBcC8AhwVlISXyWnUAjA/cAZSTe1HaSuVAoBuA/4XNItbQepI6VCAO4m233tbDtIVakVAnAXcF7SHW0HqSLFQiC7fuWcpDvbDjKsVAsB2AGcknRD20GG0dhZJ5F4EpgD/gghXGk7TBUpbCEfAKfyf8+EEH6f1DLWVTg5eM05R4OeH3G2b/LVviMpSLo3f7wkadc4s/RkGu14RV7I15JeLkw7n0c5Mc4sPevvdCEPlkx7No+yKGnHOPPk6+9uIWWUXal0KY/zQgvrb2S8kvmUFUJYknQU+Bs43Xaeqhq7HMEnWzczXil87E2KC4mMC4mMC4mMC4mMC4lMY8chMRwcpsBbSGTqFLLQWIr0zFd9YZ1CDtVZccLmycamWZL+Kvw+zDefqUhrbz5zud+8620hPxceP9RMvE56uPD4p6GXIOlYodU5+QZmQ5O0VdKXhbF8s8qCdir7SrRYyn4ldsb5KOS7qcdLyliSdGu/1wVJT5Dd98q3WmpXdp8tSQtA38ZsrOangGSurUjA9VPApbZT2FW/bgIukJ2gvOIfYHcIwQd9I5S/sf8I9F4neQFJzxTPiJD0YUs5O0PS6ZJxfwpJmyVdLHny9bZDp0rSkZLx/kHS5pUZZiQtl8x0TtJeH3fUlx+X7JP0Wck4L0s6CD2nAUk6DrzaWuJuOxZCOAyrv6A6nP98hSH+0IvVIuA48NrKhDUDL2kGOAHsHl+uTroIvBRC+LR3YumWkL+5zJBdAPMAsAvw+0g9f5J9V/IV8DHwSQjh33YjmZmZmZmZmZmZmZmZjd//1+f0TbXXU2QAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineBusinessIcon);
export default __webpack_public_path__ + "static/media/OnlineBusinessIcon.f41570144de839a5637f8151ddf82e6a.svg";
export { ForwardRef as ReactComponent };